module.exports = __webpack_public_path__ + "img/BS_FS_AS_Preisliste_4_2022_DE_AU-Thumbnail.c3d53447.png";